/**
 * Off-site destinations, shared so the bar, the footer, and the team section
 * cannot drift apart. Contact is not here: it opens ContactDialog, which owns
 * its own recipient because it composes a structured draft rather than a bare
 * address.
 */
export const CAREERS_URL = "https://jobs.ashbyhq.com/backbone";
